// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"320cb2b8","239":"37865d7c","732":"532b08b7"}[chunkId] + ".chunk.js";
};